var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('busqueda-en-fecha',{on:{"seleccionada":_vm.onBusquedaEnFecha}}),_c('div',{staticClass:"charts-container"},[_c('graficos-ventas-ciudad',{attrs:{"fecha":_vm.fechaSeleccionada}}),_c('graficos-vendidos',{attrs:{"fecha":_vm.fechaSeleccionada}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }